exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotel-list[data-v-722ec49e]{background-color:#f0f0f0;height:100%}.hotel-list-container[data-v-722ec49e]{padding:20px;width:100%}", ""]);

// exports
